import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to every request via 'x-auth-token'
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('webToken');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

interface UploadedImage {
  _id: string;
  filename: string;
  url: string;
  mimetype?: string;
  size?: number;
  uploadedAt: string;
}


export const WEBApi = {
  login: async (email: string, password: string) => {
    const response = await api.post('/api/login', { email, password });
    return response.data;
  },

  // getProfile: async () => {
  //   const response = await api.get('/api/profile');
  //   return response.data;
  // },

  getUser: async () => {
    const response = await api.get('/api/auth', {});

    return response.data;
  },

  // List blogs with pagination
  getBlogs: async (page: number) => {
    const response = await api.get(`/api/blog/list?page=${page}`);
    return response.data;
  },

  getBlogById: async (id: string) => {
    const response = await api.get(`/api/blog/${id}`);
    return response.data;
  },

  // Create a new blog
  createBlog: async (blogData: { title: string; author: string; content: string, image:string, blob:string }) => {
    const response = await api.post('/api/blog', blogData);
    return response.data;
  },

  // Edit an existing blog
  updateBlog: async (id: string, blogData: { title: string; author: string; content: string, image:string, blob:string }) => {
    const response = await api.put(`/api/blog/${id}`, blogData);
    return response.data;
  },

  // Delete a blog
  deleteBlog: async (id: string) => {
    const response = await api.delete(`/api/blog/${id}`);
    return response.data;
  },
  // List recognitions with pagination (admin or full)
  getRecognitions: async (page: number) => {
    const response = await api.get(`/api/recognition/list?page=${page}`);
    return response.data;
  },

  // Public list of published recognitions (no pagination assumed)
  getPublishedRecognitions: async () => {
    const response = await api.get('/api/recognitions');
    return response.data;
  },

  // Get recognition by ID (for view or edit)
  getRecognitionById: async (id: string) => {
    const response = await api.get(`/api/recognition/${id}`);
    return response.data;
  },

  // Create a new recognition
  createRecognition: async (data: {
    title: string;
    content: string;
    image?: string;
    date: string;
    published: boolean;
    url: string;
    showURL: boolean;
    orderNo:number;
  }) => {
    const response = await api.post('/api/recognition', data);
    return response.data;
  },  

  // Update a recognition
  updateRecognition: async (
    id: string,
    data: {
      title: string;
      content: string;
      image?: string;
      date?: Date | string;
      published?: boolean;
      url: string;
      showURL: boolean;
      orderNo: number;
    }
  ) => {
    const response = await api.put(`/api/recognition/${id}`, data);
    return response.data;
  },  

  // Delete a recognition
  deleteRecognition: async (id: string) => {
    const response = await api.delete(`/api/recognition/${id}`);
    return response.data;
  },

  // CONTACT API
  getContacts: async (page: number) => {
    const response = await api.get(`/api/contact/list?page=${page}`);
    return response.data;
  },
  deleteContact: async (id: string) => {
    const response = await api.delete(`/api/contact/${id}`);
    return response.data;
  },

  getUploadedImages: async (page: number = 1): Promise<{
    images: UploadedImage[];
    totalPages: number;
  }> => {
    const response = await api.get(`/api/images?page=${page}`);
    return response.data;
  },

  // Delete an uploaded image by ID
  deleteImage: async (id: string): Promise<void> => {
    await api.delete(`/api/images/${id}`);
  },
  uploadImage: async (formData: FormData): Promise<{ url: string }> => {
    const response = await api.post('/api/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  
  uploadImageChunk: async (formData: FormData): Promise<{ message: string }> => {
    const response = await api.post('/api/images/upload-chunk', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  
  mergeChunks: async (data: {
    fileId: string;
    totalChunks: number;
    originalName: string;
  }): Promise<{ url: string }> => {
    const response = await api.post('/api/images/merge-chunks', data);
    return response.data;
  },
  
  

};
